






import { Component, Vue, Prop } from 'vue-property-decorator';
import { IIssue } from '@/lib/interfaces';

@Component
export default class IssueIcon extends Vue {
  @Prop() private type!: string;

  private get iconClassName(): string {
    switch (this.type) {
      case '5bc495b7c71ed2f900356a9f':
        return 'task-icon';
      case '5bc495aac71ed2f900356a9d':
        return 'bug-icon';
      default:
        return 'task-icon';
    }
  }
}
